var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 42,
    viewBox: "0 0 87 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3844 10.1409L87 0L47.3615 16.9585L62.4972 31.7434L0 42L39.52 24.9258L24.3844 10.1409Z",
    fill: "url(#paint0_linear_2159_2246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2159_2246",
    x1: 87,
    y1: -0.00000238723,
    x2: 56.5384,
    y2: 66.1694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80FF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignals);
export default __webpack_public_path__ + "static/media/signals.65ecb8909fe3c2da524685628ce6dd5d.svg";
export { ForwardRef as ReactComponent };